import { useState, useEffect } from 'react';
import { Button } from '@wearenotch/ui-react';
import styles from './AgentProgressDemo.module.css';

const STEPS = [
  'Reading your inputs...',
  'Structuring work history...',
  'Writing personal statement...',
  'Checking for gaps in employment...',
  'Finalising and formatting...',
];

const STEP_DELAY = 800;

function Spinner() {
  return <span className={styles.spinner} aria-hidden="true" />;
}

function Check() {
  return (
    <svg className={styles.check} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function AgentProgressDemo() {
  const [started, setStarted] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!started) return;

    if (activeStep < STEPS.length) {
      const t = setTimeout(() => setActiveStep(s => s + 1), STEP_DELAY);
      return () => clearTimeout(t);
    } else {
      const t = setTimeout(() => setDone(true), STEP_DELAY);
      return () => clearTimeout(t);
    }
  }, [started, activeStep]);

  function handleStart() {
    setStarted(true);
    setActiveStep(0);
    setDone(false);
  }

  function handleReset() {
    setStarted(false);
    setActiveStep(0);
    setDone(false);
  }

  if (!started) {
    return (
      <div className={styles.start}>
        <Button variant="primary" onClick={handleStart}>
          Generate CV
        </Button>
        <p className={styles.startSub}>See how the agent communicates its progress</p>
      </div>
    );
  }

  return (
    <div className={styles.progress}>
      <ul className={styles.steps}>
        {STEPS.map((label, i) => {
          const isComplete = i < activeStep;
          const isActive = i === activeStep && !done;
          const isPending = i > activeStep;

          return (
            <li
              key={i}
              className={`${styles.step} ${isComplete ? styles.complete : ''} ${isActive ? styles.active : ''} ${isPending ? styles.pending : ''}`}
            >
              <span className={styles.stepIcon}>
                {isComplete ? <Check /> : isActive ? <Spinner /> : <span className={styles.dot} />}
              </span>
              <span className={styles.stepLabel}>{label}</span>
            </li>
          );
        })}
      </ul>

      {done && (
        <div className={styles.result}>
          <svg className={styles.resultIcon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          <span className={styles.resultText}>CV ready to review</span>
        </div>
      )}

      {done && (
        <div className={styles.resetRow}>
          <Button variant="tertiary" size="sm" onClick={handleReset}>
            Run again
          </Button>
        </div>
      )}
    </div>
  );
}
